import React, { useState } from 'react';
import s from './UserList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Button from 'react-bootstrap/Button';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const UserListTable = ({
  adminResetUserPassword,
  paginatedData = [],
  intl,
  currentPage = 1,
  UpdateAllowed,
  ResetAllowed
}) => {
  const [active, setActive] = useState(false);
  const [resetId, setResetId] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const currentOrganisationId = Cookies.get(`selectedorganisationid-${envName}`) || -1;
  const history = useNavigate();

  const dialogTitle = intl.formatMessage({
    id: 'usermanagment.resetUserPassword',
    defaultMessage: "Are you sure you want to reset this user's password?"
  });

  const handleClose = () => {
    setResetId('');
    setResetEmail('');
    setActive(false);
  };

  const handleConfirm = () => {
    adminResetUserPassword({ id: resetId, email: resetEmail });
    handleClose();
  };

  const resetPasswordHandler = (id, email) => {
    setResetId(id);
    setResetEmail(email);
    setActive(true);
  };

  const onEditLink = id => {
    history(`/admin-controls/user/${id}`);
  };

  return (
    <div className={s.wsTableContainer}>
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th className="d-none d-sm-table-cell">
              <FormattedMessage id="usermanagment.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="usermanagment.email" defaultMessage="Email" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="usermanagment.usermanagment.contactno" defaultMessage="Contact No" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="usermanagment.active" defaultMessage="Active" />
            </th>
            <th className="d-none d-md-table-cell"></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr data-unittest="userlistdata" key={n.UserId}>
                <td className="d-none d-sm-table-cell">{`${n.FullName || ''} `} {n.IsSupportUser ? <span className={`badge rounded-pill ${s.badgeColor}`}><FormattedMessage id="usermanagment.supportUser" defaultMessage="Support User" /></span> : ''}</td>
                <td>{n.Email || ''}</td>
                <td className="d-none d-md-table-cell">{n.PhoneNumber || ''}</td>
                <td className="d-none d-md-table-cell">{n.IsActive ? 'Yes' : 'No'}</td>
                {!n.IsSupportUser || n.CreatedOrganisationId === parseInt(currentOrganisationId) ?
                  <td className="d-none d-md-table-cell">

                    {ResetAllowed ? (
                      <Button
                        variant="outline-secondary"
                        className={s.resetbutton}
                        onClick={() => resetPasswordHandler(n.GuidIdentifier, n.Email)}
                        data-unittest="resetPasswordHandler"
                      >
                        <FormattedMessage id="usermanagement.resetUserPassword" defaultMessage="RESET PASSWORD" />
                      </Button>
                    ) : null}
                    {UpdateAllowed ? (

                      <Button
                        variant="outline-secondary"
                        className={s.viewButton}

                        onClick={() => {
                          onEditLink(n.UserId);
                        }}
                        data-unittest="changeData"
                      >
                        <FormattedMessage id="usermanagement.edit" defaultMessage="EDIT" />
                      </Button>
                    ) : null}
                  </td>
                  :
                  <td className="d-none d-md-table-cell"></td>
                }
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default injectIntl(UserListTable);